import {
    Component,
    h,
    Host,
    State,
    Listen,
    Prop,
    Element,
} from "@stencil/core";

@Component({
    tag: "ux-iws-price-box",
    styleUrl: "price-box.scss",
})
export class PriceBox {
    private baseClass = "ux-iws-price-box";

    @Element() priceBox: HTMLUxIwsPriceBoxElement;

    /** Set breakpoint for desktop */
    @Prop() breakpointDesktop: number = 1440;

    @State() fixed: boolean = false;
    @State() absolute: boolean = false;
    @State() hasUserScrolled: boolean = false;
    @State() priceBoxWidth: number;
    @State() windowWidth: number;

    @Listen("scroll", { target: "window" })
    onScroll() {
        this.hasUserScrolled = true;
        this.initPriceBox(
            this.priceBox,
            this.scrollContainer,
            this.priceBoxMax
        );
    }

    @Listen("load", { target: "window" })
    onLoad() {
        this.initPriceBox(
            this.priceBox,
            this.scrollContainer,
            this.priceBoxMax
        );
    }

    @Listen("resize", { target: "window" })
    onResize() {
        this.priceBoxWidth = parseFloat(
            document.defaultView.getComputedStyle(
                this.priceBox.parentElement,
                ""
            ).width
        );
        this.windowWidth = window.innerWidth;
        this.initPriceBox(
            this.priceBox,
            this.scrollContainer,
            this.priceBoxMax
        );
    }

    private priceBoxMax: HTMLElement;
    private scrollContainer: HTMLElement;

    componentDidRender() {
        this.priceBoxWidth = parseFloat(
            document.defaultView.getComputedStyle(
                this.priceBox.parentElement,
                ""
            ).width
        );

        this.setBoxWidth(this.priceBox);

        this.scrollContainer = document.querySelector(
            ".ux-iws-price-box-scroll-container"
        ) as HTMLElement;

        this.priceBoxMax = document.querySelector(
            ".ux-iws-price-box-max"
        ) as HTMLElement;
    }

    private initPriceBox(
        priceBox: HTMLElement,
        scrollContainer: HTMLElement,
        priceBoxMax: HTMLElement
    ) {
        this.windowWidth = window.innerWidth;

        const priceBoxHeight = parseFloat(
            document.defaultView.getComputedStyle(priceBox, "").height
        );
        const priceBoxMaxHeight = parseFloat(
            document.defaultView.getComputedStyle(priceBoxMax, "").height
        );

        if (priceBoxMaxHeight > priceBoxHeight) {
            this.setBoxPosition(priceBox, scrollContainer);
        }
    }

    private setBoxWidth(priceBox) {
        priceBox.style.width = `${this.priceBoxWidth}px`;
    }

    private setBoxPosition(
        priceBox: HTMLElement,
        scrollContainer: HTMLElement
    ) {
        const priceBoxMarginTop = parseFloat(
            document.defaultView.getComputedStyle(priceBox, "").marginTop
        );

        const priceBoxMarginBottom = parseFloat(
            document.defaultView.getComputedStyle(priceBox, "").marginBottom
        );

        const isTopOfScrollContainerOutOfScreen =
            scrollContainer.getBoundingClientRect().top < 0;

        const isScrollContainerBottomOnPriceBoxPosition =
            scrollContainer.getBoundingClientRect().bottom -
                (priceBox.getBoundingClientRect().height +
                    priceBoxMarginBottom +
                    priceBoxMarginTop) <=
            0;

        if (isTopOfScrollContainerOutOfScreen === true) {
            this.setBoxWidth(priceBox);
            this.fixed = true;
            this.absolute = false;
        }

        if (isTopOfScrollContainerOutOfScreen === false) {
            this.setBoxWidth(priceBox);
            this.fixed = false;
            this.absolute = false;
        }

        if (isScrollContainerBottomOnPriceBoxPosition) {
            this.setBoxWidth(priceBox);
            this.fixed = false;
            this.absolute = true;
        }
    }

    render() {
        return (
            <Host
                class={{
                    [`${this.baseClass}`]: true,
                    [`${this.baseClass}--fixed`]: this.fixed,
                    [`${this.baseClass}--absolute`]: this.absolute,
                }}
            >
                <slot />
            </Host>
        );
    }
}
